// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PayorSaveModel {
    static getAttributeTypeMap() {
        return PayorSaveModel.attributeTypeMap;
    }
}
PayorSaveModel.discriminator = undefined;
PayorSaveModel.attributeTypeMap = [
    {
        "name": "payorName",
        "baseName": "payorName",
        "type": "string"
    },
    {
        "name": "payorType",
        "baseName": "payorType",
        "type": "PayorType"
    },
    {
        "name": "payorBin",
        "baseName": "payorBin",
        "type": "string"
    },
    {
        "name": "payorPcn",
        "baseName": "payorPcn",
        "type": "string"
    },
    {
        "name": "payorGroup",
        "baseName": "payorGroup",
        "type": "string"
    },
    {
        "name": "isPlaceholder",
        "baseName": "isPlaceholder",
        "type": "boolean"
    }
];
//# sourceMappingURL=payorSaveModel.js.map